import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRunLikes } from "@/hooks/useRunLikes";

interface LikeButtonProps {
  runId: string;
  size?: "sm" | "default" | "lg";
  showCount?: boolean;
  className?: string;
}

export function LikeButton({ runId, size = "default", showCount = true, className }: LikeButtonProps) {
  const { likeCount, isLiked, isLoading, toggleLike } = useRunLikes(runId);

  const sizeClasses = {
    sm: "h-8 px-2 text-xs",
    default: "h-9 px-3 text-sm",
    lg: "h-10 px-4 text-base",
  };

  const iconSizes = {
    sm: "h-3.5 w-3.5",
    default: "h-4 w-4",
    lg: "h-5 w-5",
  };

  return (
    <Button
      variant={isLiked ? "default" : "outline"}
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        toggleLike();
      }}
      disabled={isLoading}
      className={cn(
        sizeClasses[size],
        isLiked 
          ? "bg-destructive hover:bg-destructive/90 border-destructive text-destructive-foreground"
          : "text-foreground hover:text-destructive hover:border-destructive/50",
        "gap-1.5 transition-all",
        className
      )}
    >
      <Heart
        className={cn(
          iconSizes[size],
          isLiked && "fill-current",
          "transition-transform",
          isLiked && "scale-110"
        )}
      />
      {showCount && likeCount > 0 && (
        <span>{likeCount}</span>
      )}
      {showCount && likeCount === 0 && !isLiked && (
        <span className="hidden sm:inline">Like</span>
      )}
    </Button>
  );
}
